import React from 'react';

const Filter = () => {
    return (
        <div>
            <h1>Filter Page</h1>
        </div>);
}

export default Filter;